// auth.tsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { API_BASE_URL } from "./config";

type AuthCtx = {
  accessToken: string | null;
  language: string ;
  linkedCustomerId: string;
  setAccessToken: (t: string | null) => void;
  setLanguage: (t: string ) => void;
  initializing: boolean;
  login: (u: string, p: string) => Promise<void>;
  logout: () => Promise<void>;
};

const Ctx = createContext<AuthCtx | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [linkedCustomerId, setCustomer] = useState<string>("");
  const [language, setLanguage] = useState<string>("de");
  const [initializing, setInitializing] = useState(true);

  // On page reload: verify the AUTH cookie is still valid by calling a protected endpoint.
  // If the server replies with anything other than 401, the session is alive.
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/Admin/Refresh`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        });
        if (res.ok && !res.redirected) {
          setAccessToken("loggedin");
        }
      } catch {
        // network error – leave accessToken null, user will see login
      } finally {
        setInitializing(false);
      }
    })();
  }, []);

  const login = async (username: string, password: string): Promise<void> => {

    

    //const csrfToken = await getCsrfToken();
    const res = await fetch(`${API_BASE_URL}/Home/LoginWebcastManager?adminname=${username}&adminpass=${password}`, {
      method: "POST",
      headers: {
      "Content-Type": "application/json",
     // "X-CSRF-TOKEN": csrfToken,
    },
      credentials: "include", // receive refresh cookie
      //body: JSON.stringify({ adminname: username, adminpass: password }),
    });
    if (!res.ok) {
      const e = await res.text();
      throw new Error(e);
    }
    //const data = await res.json();
    setAccessToken("loggedin");
    //sessionStorage.setItem("refreshToken", data.refreshToken);
  };

  const logout = async () => {
    
         setAccessToken(null);
         // sessionStorage.setItem("refreshToken", "");
   

    window.location.href = "/";
      
  };

  return (
    <Ctx.Provider value={{ accessToken, language, linkedCustomerId, setAccessToken, setLanguage, initializing, login, logout }}>
      {children}
    </Ctx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
}
